import PropTypes from 'prop-types';
// material
import { Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        Nie znaleziono
      </Typography>
      <Typography variant="body2" align="center">
        Nie znaleziono rekordu dla obecnego zapytania &nbsp;
        <strong>&quot;{searchQuery}&quot;</strong>. Spróbuj wprowadzić inne słowo!
      </Typography>
    </Paper>
  );
}
